import Splide from '@splidejs/splide';

class NewsCross {
    constructor() {
        const elem = document.querySelector('.splide.blockNews__slider');

        if (elem) {
            const splide = new Splide(elem, {
                perMove: 1,
                pagination: false,
                arrows: true,
                autoWidth: true,
                gap: '1rem',
            });

            splide.mount();
        }
    }
}

export default NewsCross;
